import i18n from "@/bootstrap/translations";
import { validation } from "@/domain/validation";
import { auth } from "@/endpoints/dryp/auth";
import { useFormHandler } from "@/hooks/useFormHandler";
import { useAsyncStateStore } from "@/hooks/useAsyncStateStore";
import { useParams } from "react-router";
import { z } from "zod";

const validationFormSchema = z
	.object({
		password: validation.passwordWithRules,
		confirmPassword: validation.passwordWithRules,
	})
	.refine(({ password, confirmPassword }) => password === confirmPassword, {
		message: i18n.t("shared.forms.password.password_match"),
		path: ["confirmPassword"],
	});

/** 🔹 Infer form values type */
type ResetPasswordFormValues = z.infer<typeof validationFormSchema>;

export const useResetPassword = () => {
	let { token = "", userId } = useParams();
	const restPasswordApi = useAsyncStateStore(auth.resetPassword);
	const { success, loading, error } = restPasswordApi;
	const { form, handleFormErrors } = useFormHandler(validationFormSchema);
	const onSubmit = async ({ password }: ResetPasswordFormValues) => {
		try {
			const payloadUserId = userId as Dryp.UserId;
			await restPasswordApi.fetch({ password, token, userId: payloadUserId });
		} catch (error) {
			handleFormErrors(error);
			throw error;
		}
	};

	return {
		form,
		onSubmit,
		loading,
		showForm: !success,
		error,
	};
};
